import { CIRCULAR_STD } from 'reservations/brand/helpers/fonts';

export const defaultTypography = {
  fontFamily: `${CIRCULAR_STD}, Helvetica Neue, Arial, sans-serif`
};

export const getTypography = () => {
  return {
    ...defaultTypography,
    h1: {
      fontSize: '2.625rem',
      fontWeight: '400'
    },
    h2: {
      fontSize: '1.25rem',
      fontWeight: 'lighter'
    }
  };
};
